import React from 'react';
import { Container, ErrorMessage, TextareaAutosize } from './style';
import { If } from 'components/if-statement';

function Textautosize(props) {
  // TODO: implement full feature list like text-input (https://jira.9y.engineering/browse/COR-304)
  const {
    autoFocus,
    placeholder,
    errorMessage,
    invalid,
    className,
    onChange,
    value,
  } = props;

  return (
    <Container>
      <TextareaAutosize
        $invalid={invalid}
        placeholder={placeholder}
        className={className}
        autoFocus={autoFocus}
        onChange={onChange}
        value={value}
      />
      <If condition={invalid}>
        <ErrorMessage>{errorMessage}</ErrorMessage>
      </If>
    </Container>
  );
}

export default Textautosize;
